'use strict';

var curry = require('./curry.js');
require('./chunk-d7703e54.js');
require('./variadic.js');
require('./chunk-e6d921c6.js');
require('./head.js');
require('./tail.js');
require('./copy.js');
require('./chunk-fac2c876.js');
var _set = require('./_set.js');

/**
 * Sets a property of an object using a key path.
 *
 * @function
 * @param {Array|String} ks The key path.
 * @param v The value to set.
 * @param {Object} o The object.
 * @returns {Object} A copy of the object `o` with the property at the key
 * path `ks` set to the value `v`.
 * @example
 *
 * import { set } from 'fkit'
 * const person = { name: 'Jane', age: 20, address: { city: 'Melbourne', country: 'Australia' } }
 * set('name', 'Steve', person) // { name: 'Steve', age: 20, address: { city: 'Melbourne', country: 'Australia' } }
 * set('address.city', 'Sydney', person) // { name: 'Jane', age: 20, address: { city: 'Sydney', country: 'Australia' } }
 */

var set = curry(_set);

module.exports = set;
